export const VALID_EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email: string): boolean => {
  // Basic email validation regex pattern
  return VALID_EMAIL_REGEX.test(email);
};
